// File: src/services/aiCreditsService.ts
import apiClient from './api';
import { AICreditBalance, AICreditTransaction, StripeCheckoutSession, AICreditPack, AICreditPurchasePayload } from '../types';

const BASE_URL = '/ai-credits';

/**
 * Fetches the current AI credit balance for the authenticated coach.
 */
const getBalance = async (): Promise<AICreditBalance> => {
    const { data } = await apiClient.get<AICreditBalance>(`${BASE_URL}/me/balance`);
    return data;
};

/**
 * Fetches the transaction history for the authenticated coach.
 * @param {number} skip - Pagination offset.
 * @param {number} limit - Number of records to fetch.
 */
const getTransactions = async (skip = 0, limit = 20): Promise<AICreditTransaction[]> => {
    const { data } = await apiClient.get<AICreditTransaction[]>(`${BASE_URL}/me/transactions`, {
        params: { skip, limit }
    });
    return data;
};

/**
 * Creates a Stripe Checkout session for purchasing AI credits.
 * @param {AICreditPurchasePayload} payload The payload containing the pack_id.
 */
const createPurchaseSession = async (payload: AICreditPurchasePayload): Promise<StripeCheckoutSession> => {
    // --- CONSOLE LOG ADDED FOR DEBUGGING ---
    console.log('[aiCreditsService] Sending payload to /ai-credits/me/purchase:', JSON.stringify(payload, null, 2));
    // -----------------------------------------
    
    const { data } = await apiClient.post<StripeCheckoutSession>(`${BASE_URL}/me/purchase`, payload);
    return data;
};

/**
 * Fetches all active and visible AI credit packs for a coach to purchase.
 */
const getPurchaseOptions = async (): Promise<AICreditPack[]> => {
    const { data } = await apiClient.get<AICreditPack[]>('/ai-credits/purchase-options');
    return data;
};

export default {
    getBalance,
    getTransactions,
    createPurchaseSession,
    getPurchaseOptions,
};